import React from 'react';
import { Folder, Plus } from 'lucide-react';
import type { Folder as FolderType } from '../../hooks/useNotes';

interface FolderSidebarProps {
  folders: FolderType[];
  selectedFolder: string | null;
  onFolderSelect: (folderId: string | null) => void;
  onManageFolders: () => void;
}

export function FolderSidebar({
  folders,
  selectedFolder,
  onFolderSelect,
  onManageFolders,
}: FolderSidebarProps) {
  return (
    <aside className="hidden md:block w-64 flex-shrink-0">
      <div className="bg-[#2A2B2E] rounded-3xl p-4 sticky top-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-semibold">Folders</h2>
          <button
            onClick={onManageFolders}
            className="p-2 hover:bg-black/20 rounded-lg transition-colors"
          >
            <Plus className="w-4 h-4" />
          </button>
        </div>

        <div className="space-y-1">
          <button
            onClick={() => onFolderSelect(null)}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
              selectedFolder === null
                ? 'bg-[#bbdde5] text-black'
                : 'hover:bg-black/20'
            }`}
          >
            <Folder className="w-4 h-4" />
            <span>All Notes</span>
          </button>
          {folders.map((folder) => (
            <button
              key={folder.id}
              onClick={() => onFolderSelect(folder.id)}
              className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
                selectedFolder === folder.id
                  ? 'bg-[var(--accent-color)] text-black'
                  : 'hover:bg-black/20'
              }`}
            >
              <div
                className="w-4 h-4 rounded-lg"
                style={{ backgroundColor: folder.color || '#9FFF32' }}
              />
              <span className="truncate">{folder.name}</span>
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
}